import { Button } from "primereact/button";
import { FaShop } from "react-icons/fa6";
import { Link } from "react-router-dom";

const TokoBox = (props) => {
  const { toko } = props;

  return (
    <div className="col-start-start px-3 sm:px-5 py-2 bg-white w-full shadow-xs">
      <Link className="row-start-center gap-3 w-full" to={`/toko/${toko.id}`}>
        <FaShop className="bg-slate-500 text-white p-3 rounded-full min-w-[3.2rem] min-h-[3.2rem]" />
        <div className="col-start-start">
          <span className="font-bold text-slate-700">{toko.nama_toko}</span>
          <span className="text-xs text-slate-500">{toko.alamat}</span>
        </div>
      </Link>
    </div>
  );
};

export default TokoBox;
